import { Timestamp } from 'firebase/firestore';

/**
 * Formatea un número como moneda en Quetzales, con comas para miles.
 * @param {number} value El número a formatear.
 * @returns {string} El número formateado como 'Q1,234.56'.
 */
export const formatCurrency = (value) => {
    return `Q${Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/**
 * Formatea un objeto de fecha (Date o Timestamp de Firebase) a un string dd/mm/yyyy.
 * @param {Date|Timestamp} date La fecha a formatear.
 * @returns {string} La fecha formateada o 'N/A'.
 */
export const formatDate = (date) => {
    if (!date) return 'N/A';
    const d = date instanceof Timestamp ? date.toDate() : new Date(date);
    if (isNaN(d.getTime())) return 'Fecha Inválida';
    return d.toLocaleDateString('es-GT', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/**
 * Formatea una fecha para los inputs de tipo "date".
 * @param {Date|Timestamp} date La fecha a formatear.
 * @returns {string} La fecha en formato yyyy-mm-dd.
 */
export const formatDateForInput = (date) => {
    if (!date) return '';
    const d = date instanceof Timestamp ? date.toDate() : new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.toISOString().split('T')[0];
};

/**
 * Convierte una fecha de un input a un objeto Date de Javascript.
 * @param {string} dateInput La fecha en formato string (yyyy-mm-dd).
 * @returns {Date|null} El objeto Date o null si es inválido.
 */
export const getSafeDate = (dateInput) => {
    if (!dateInput) return null;
    if (typeof dateInput === 'string' && dateInput.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const [year, month, day] = dateInput.split('-').map(Number);
        const d = new Date(year, month - 1, day);
        // Validar que la fecha sea real
        if (d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day) {
            return d;
        }
    }
    return new Date(dateInput); // Fallback para otros formatos
};